module.exports = __webpack_public_path__ + "static/media/Aufnahmebogen.d39da232.pdf";